import React from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import RelatorioIngressos from "../components/RelatorioIngressos";

const RelatorioIngressosPage = () => {
    return (
        <>
            <div className="main-content">
                <Navbar/>
            </div>
            <div className="content">
                <Sidebar/>
            </div>
            <div className='table-ingressos'>
                <RelatorioIngressos/>
            </div>
        </>
    );
};

export default RelatorioIngressosPage;